export const CompanyAddressFieldNames = {
  CompanyPhysicalAddress: 'companyPhysicalAddress',
  CompanyPhysicalAddressDetails: 'companyPhysicalAddressDetails',
  CompanyPhysicalCity: 'companyPhysicalCity',
  CompanyPhysicalState: 'companyPhysicalState',
  CompanyPhysicalZipCode: 'companyPhysicalZipCode',
  CompanyMailingAddress: 'companyMailingAddress',
  CompanyMailingAddressDetails: 'companyMailingAddressDetails',
  CompanyMailingCity: 'companyMailingCity',
  CompanyMailingState: 'companyMailingState',
  CompanyMailingZipCode: 'companyMailingZipCode',
} as const;

export type CompanyAddressFields = {
  [CompanyAddressFieldNames.CompanyPhysicalAddress]?: string;
  [CompanyAddressFieldNames.CompanyPhysicalAddressDetails]?: string;
  [CompanyAddressFieldNames.CompanyPhysicalCity]?: string;
  [CompanyAddressFieldNames.CompanyPhysicalState]?: string;
  [CompanyAddressFieldNames.CompanyPhysicalZipCode]?: string;
  [CompanyAddressFieldNames.CompanyMailingAddress]?: string;
  [CompanyAddressFieldNames.CompanyMailingAddressDetails]?: string;
  [CompanyAddressFieldNames.CompanyMailingCity]?: string;
  [CompanyAddressFieldNames.CompanyMailingState]?: string;
  [CompanyAddressFieldNames.CompanyMailingZipCode]?: string;
};
